var render = function render(){var _vm=this,_c=_vm._self._c;return _c('capillaries-template',{attrs:{"prominent-blood-vessels":_vm.prominentBloodVessels,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }